enum UserConstants {
  GET_USERS_LIST = "GET_USERS_LIST",
  GET_USERS_LIST_SUCCESS = "GET_USERS_LIST_SUCCESS",
  GET_USERS_LIST_FAILURE = "GET_USERS_LIST_FAILURE",

  GET_USER_SIGNUP_REQUEST = "GET_USER_SIGNUP_REQUEST",
  GET_USER_SIGNUP_SUCCESS = "GET_USER_SIGNUP_SUCCESS",
  GET_USER_SIGNUP_FAILURE = "GET_USER_SIGNUP_FAILURE",

  UPDATE_SIGNUP_REQUEST = "UPDATE_SIGNUP_REQUEST",
  UPDATE_SIGNUP_SUCCESS = "UPDATE_SIGNUP_SUCCESS",
  UPDATE_SIGNUP_FAILURE = "UPDATE_SIGNUP_FAILURE",

  SEND_USER_SIGNUP_REQUEST = "SEND_USER_SIGNUP_REQUEST",
  SEND_USER_SIGNUP_SUCCESS = "SEND_USER_SIGNUP_SUCCESS",
  SEND_USER_SIGNUP_FAILURE = "SEND_USER_SIGNUP_FAILURE",

  GET_USER_DETAILS = "GET_USER_DETAILS",
  GET_USER_DETAILS_SUCCESS = "GET_USER_DETAILS_SUCCESS",
  GET_USER_DETAILS_FAILURE = "GET_USER_DETAILS_FAILURE",

  CREATE_USER_REQ = "CREATE_USER_REQ",
  CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS",
  CREATE_USER_FAILURE = "CREATE_USER_FAILURE",

  EDIT_USER_REQUEST = "EDIT_USER_REQUEST",
  EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS",
  EDIT_USER_FAILURE = "EDIT_USER_FAILURE",

  GET_ROLES_LIST = "GET_ROLES_LIST",
  GET_ROLES_LIST_SUCCESS = "GET_ROLES_LIST_SUCCESS",
  GET_ROLES_LIST_FAILURE = "GET_ROLES_LIST_FAILURE",

  LOGIN_REQUEST = "LOGIN_REQUEST",
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  LOGIN_FAILURE = "LOGIN_FAILURE",

  LOGOUT_REQUEST = "LOGOUT_REQUEST",
  LOGOUT_SUCCESS = "LOGOUT_SUCCESS",
  LOGOUT_FAILURE = "LOGOUT_FAILURE",

  REFRESH_TOKEN_REQUEST = "REFRESH_TOKEN_REQUEST",
  REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS",
  REFRESH_TOKEN_FAILURE = "REFRESH_TOKEN_FAILURE",

  RESET_SIGNUP_REQUEST = "RESET_SIGNUP_REQUEST",
  RESET_USERS = "RESET_USERS",
}

export default UserConstants;
